import React from 'react';
import ILoaderProps from '../../types/ILoaderProps';
import Loader from '../../components/loader/Loader';

const LoaderContainer: React.FC<ILoaderProps> = (props: ILoaderProps) => {
  return <Loader {...props} />
};

export { LoaderContainer };
export default LoaderContainer;